import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { FILES } from '../../config';

function init() {
  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      fallbackLng: 'en',
      lng: 'en',
      ns: ['common', 'validation'],
      preload: ['en'],
      defaultNS: 'common',
      partialBundledLanguages: true,
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: `${FILES}/locales/{{ns}}/{{lng}}.json`,
        allowMultiLoading: false,
        crossDomain: true,
      },
      saveMissing: false,
      missingKeyHandler: (lng, ns, key) => {
        throw new Error(
          `Missing i18n key ${[lng].flat().join(',')}:${ns}:${key}`
        );
      },
    });
}

if (process.env.NODE_ENV !== 'test') {
  init();
}

export default i18n;
